import { COMPANY_SOURCE_BADGE_ABBREVIATIONS } from 'shared/companySource/companySourceConfig';

/** FBM account names that can access the partner catalog endpoint. */
export const BA_MS_FBM_ACCOUNTS = new Set(['blue_apron', 'marley_spoon']);

export const DEFAULT_CATALOG_FILTER = 'includes_partner';
export const DEFAULT_CATALOG_PAGE = 1;
export const DEFAULT_CATALOG_PAGE_SIZE = 100;
export const CATALOG_PAGE_SIZE_OPTIONS = [25, 50, 100, 250];
export const DEFAULT_CATALOG_SORT_FIELD = 'external_sku';
export const DEFAULT_CATALOG_SORT_DIR = 'asc';

/**
 * Column id → API sortField mapping for catalog table sorting.
 * Keys are TanStack column ids; apiField values match the catalog API.
 */
export const PartnerCatalogSortConfig = {
    sortableFields: {
        external_sku: { apiField: 'external_sku' },
        name: { apiField: 'name' },
        brand: { apiField: 'brand' },
        base_unit: { apiField: 'base_unit_size' },
        l1_taxonomy_name: { apiField: 'l1_taxonomy_name' },
        l2_taxonomy_name: { apiField: 'l2_taxonomy_name' },
        l3_taxonomy_name: { apiField: 'l3_taxonomy_name' },
    },
};

/**
 * @param {string|null|undefined} fbmAccountName
 * @returns {string}
 */
export function getPartnerAbbreviation(fbmAccountName) {
    return COMPANY_SOURCE_BADGE_ABBREVIATIONS[fbmAccountName] ?? 'Partner';
}

/**
 * @param {string|null|undefined} fbmAccountName
 * @returns {Array<{ value: string, label: string }>}
 */
export function getCatalogFilterOptions(fbmAccountName) {
    const partnerAbbrev = getPartnerAbbreviation(fbmAccountName);

    return [
        { value: 'includes_partner', label: `${partnerAbbrev} catalog` },
        // { value: 'includes_mm', label: 'Misfits Market' },
        { value: 'includes_mm_excludes_partner', label: `MM Catalog (not available to ${partnerAbbrev})` },
    ];
}

/**
 * @param {Object|null|undefined} fbmAccount
 * @returns {boolean}
 */
export function isBlueApronOrMarleySpoonAccount(fbmAccount) {
    return BA_MS_FBM_ACCOUNTS.has(fbmAccount?.fbmAccountName);
}

/**
 * @param {string|null|undefined} fbmAccountName
 * @returns {string}
 */
export function getPartnerIdColumnLabel(fbmAccountName) {
    if (fbmAccountName === 'blue_apron') return 'BA ID';
    if (fbmAccountName === 'marley_spoon') return 'MS ID';
    return 'Partner ID';
}
